/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { ScrollView, TouchableOpacity, View } from "react-native";
import Rodal from "rodal";
import "rodal/lib/rodal.css";
import parse from "html-react-parser";

import { styles, Text } from "UpduoLibrary";
import {
  skaleWhite,
  skaleDarkBlue,
  skaleDeactiveGray,
  colorWithOpacity,
} from "config/UpduoColors";

interface StepDetailModalProps {
  onDismiss: Function;
  isVisible: boolean;
  stepDetail: string;
}

export default function StepDetailModal({
  onDismiss,
  isVisible,
  stepDetail,
}: StepDetailModalProps) {
  return (
    <Rodal
      customStyles={{
        marginRight: "33%",
        marginBottom: "9%",
        width: 310,
        height: 250,
        borderRadius: 12,
      }}
      customMaskStyles={{
        backgroundColor: colorWithOpacity(skaleDeactiveGray, 0.2),
      }}
      visible={isVisible}
      onClose={() => onDismiss()}
    >
      <ScrollView
        style={{
          flexGrow: 0,
          maxHeight: 230,
          marginHorizontal: 15,
        }}
      >
        <Text>{parse(stepDetail)}</Text>
      </ScrollView>
      <View style={{ position: "absolute", top: -20, right: 15 }}>
        <TouchableOpacity
          style={[styles.floatingButton, { backgroundColor: skaleDarkBlue }]}
          onPress={() => onDismiss()}
        >
          <Text
            style={{
              color: skaleWhite,
              fontWeight: "bold",
              fontStyle: "italic",
              fontSize: 12,
            }}
          >
            {"HIDE"}
          </Text>
        </TouchableOpacity>
      </View>
    </Rodal>
  );
}
